export default "./images/survio-1clxh-reference-ro.png";